import { IFileKit, IFile } from '@tencent/docs-api';
import File from './file';

export default class FileKit implements IFileKit {
    private static instance: IFileKit;
    public static getInstance(): IFileKit {
        if (!this.instance) {
            this.instance = new FileKit();
        }

        return this.instance;
    }

    public getActiveFile(): IFile {
        return File.getInstance();
    }
}
